export default __webpack_public_path__ + "static/media/overdue_invoice.0fee63c9.svg";